import React, {useEffect, useRef, useState} from "react";
import {Button, Card, FlexItem, FlexLayout, H2, Spinner, StackLayout, Text} from "@salt-ds/core";
import CardHeader from "../../components/common/card-header/CardHeader";
import Constants from "../../components/common/Constants";
import StepTracker from "../../components/common/StepTracker";
import '../CommonCard.css';
import {useIntl} from "react-intl";
import CardAlert from "../../components/common/card-alert/CardAlert";
import {useLocation, useNavigate} from "react-router";
import {deRegisterDevice,success} from "../../api/LoginApi";
import PasswordExpiringSoonModal from '../../components/common/PasswordExpiringSoonModal';
import {TargetRedirectComponent} from "../TargetRedirect/TargetRedirectComponent.tsx";

function FirstTimeLogInSetupComplete(props) {

  const location = useLocation();
  const navigate = useNavigate();
  const mainRef = useRef(null);
  const [passwordExpiryFormData, setPasswordExpiryFormData] = useState({daysUntilNextReminder: 90});
  const [showNotification, setShowNotification] = React.useState(true);
  const {registerDevice} = location.state || {};
  const [showRedirect, setShowRedirect] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isContinueDisabled, setIsContinueDisabled] = useState(false);
  const headerContent = registerDevice ? <CardAlert status={"success"} setShowNotification={setShowNotification}>
    {Constants.firstTimeLoginFlowSetupCompleteRegisterMessage}
  </CardAlert> : <CardAlert status={"info"} setShowNotification={setShowNotification}>
    {Constants.firstTimeLoginFlowSetupCompleteNotRegisterMessage}
  </CardAlert>
  const intl = useIntl()
  useEffect(() => {
    document.title = intl.formatMessage({id: 'logon.ui.firstTimeLoginSetup.step3.page.title'});
    // Set focus to main element for screen reader announcement
    if (mainRef.current) {
      mainRef.current.focus();
    }

    const expectedPreviousPage = '/firstTimeLogInSetupRegisterComputer';
    if (location.state?.from !== expectedPreviousPage) {
      navigate('/');
    }
  }, [intl]);

  useEffect(() => {
    if (!registerDevice) {
      deRegisterDevice("abc", "abc", "abc").then(response => "")
    }
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true); // Disable form on submit
    try {
      const passwordExpiryData = await success(sessionStorage.getItem("orgName"), sessionStorage.getItem("loginName")
      );
      if (passwordExpiryData.data.reminderRequired) {
        setPasswordExpiryFormData({...passwordExpiryData.data});
        props.fillAndOpenModel(<PasswordExpiringSoonModal closeAndClearModal={props.closeAndClearModal}
          fillAndOpenModel={props.fillAndOpenModel} passwordExpiryFormData={passwordExpiryData.data} setShowRedirect={setShowRedirect} useTargetRedirect={true} onRemindMeLater={() => setIsContinueDisabled(true)} />)
        setIsSubmitting(false); // Re-enable if modal is shown
      } else {
        setShowRedirect(true);
        // Spinner stays while TargetRedirectComponent handles redirect
      }
    } catch (e) {
      setIsSubmitting(false); // Re-enable on error
    }
  }
  return (
    <main ref={mainRef} role="main" aria-label="First Time Log In Setup Complete" tabIndex="-1">
      <FlexLayout className={"page-content"}>
        {showRedirect ? (
            <FlexItem className="spinner-wrapper">
              <Spinner data-testid="spinner-loading" aria-label="redirecting" role="status" size="medium" />
              <TargetRedirectComponent />
            </FlexItem>
        ) : (
            <FlexItem className={`error-wrapper ${showNotification ? 'visible' : ''}`}>
              <div>
                {headerContent}
              </div>
            </FlexItem>
        )}
        <FlexItem>
          <Card className="card-wrapper">
            <FlexItem className="card-content">
              <StackLayout gap={2}>
                <CardHeader style={{maxWidth: '21rem'}} heading={Constants.firstTimeLogInSetupTitle}
                  subheading={Constants.firstTimeLogInSetupStep3Title} />
                <StepTracker label1={intl.formatMessage({id: 'logon.ui.firstTimeLoginSetup.flow.step1'})} step1="completed"
                  label2={intl.formatMessage({id: 'logon.ui.firstTimeLoginSetup.flow.step2'})} step2="completed"
                  label3={intl.formatMessage({id: 'logon.ui.firstTimeLoginSetup.flow.step3'})} step3="completed" />
                <FlexItem>
                  <Text>
                    {registerDevice ? Constants.firstTimeLogInSetupStep3InstructionalText : Constants.firstTimeLogInSetupStep3InstructionalTextNotRegistered}
                  </Text>
                </FlexItem>
                <FlexItem>
                  <Text>
                    {registerDevice ? Constants.firstTimeLogInSetupStep3InstructionalText1 : Constants.firstTimeLoginSetupStep3InstructionalText1NotRegistered}
                  </Text>
                </FlexItem>
                {registerDevice && <><FlexItem>
                  <H2>{Constants.firstTimeLoginSetupStep3InstructionHeading}</H2>
                </FlexItem>
                  <FlexItem>
                    <Text>
                      {Constants.firstTimeLoginFlowReRegisterComputerInstruction1}
                    </Text>
                  </FlexItem>
                  <FlexItem>
                    <ul className="aligned-list">
                      <li>{Constants.firstTimeLoginFlowReRegisterComputerInstruction2}</li>
                      <li>{Constants.firstTimeLoginFlowReRegisterComputerInstruction3}</li>
                      <li>{Constants.firstTimeLoginFlowReRegisterComputerInstruction4}</li>
                      <li>{Constants.firstTimeLoginFlowReRegisterComputerInstruction5}</li>
                      <li>{Constants.firstTimeLoginFlowReRegisterComputerInstruction6}</li>
                    </ul>
                  </FlexItem></>}
                <FlexItem style={{alignSelf: 'end'}}>
                  <Button sentiment="accented" appearance="solid" type="submit" onClick={handleSubmit} disabled={isSubmitting || isContinueDisabled}>
                    CONTINUE
                  </Button>
                </FlexItem>
              </StackLayout>
            </FlexItem>

          </Card>
        </FlexItem>
      </FlexLayout>
    </main>
  );
}

export default FirstTimeLogInSetupComplete;